<!-- <div class="main-wrapper">
  <app-header></app-header>
  <div class="app-body position-relative">
      <app-sidebar></app-sidebar>
      <main class="main">
          <div class="row">
            <div class="col-md-12 all-sports">
              <h3 class="quickHeader">Quick Links</h3>
              <ul class="quick_link">
                <li><a [routerLink]="['/inplay/']"><img src="assets/images/timer.svg" alt="">In-Play</a></li>
                <li><a [routerLink]="['/multiMarket/']"><img src="assets/images/paper-push-pin.svg" alt="">Multi Markets</a></li>
                <li *ngFor="let sports of allSportsList;let i= index"><a  (click)="(sports.sport_id <= -100) ? openModalLoginCnfm(loginCnfm) : getSeriesList(sports.sport_id)"><img src="assets/images/{{sports.sport_id}}.svg" alt="">{{sports.name}}</a></li>
                
              </ul>
              <div class="sidebar">
                <nav class="sidebar-nav" *ngIf="sportList == true">
                  <div class="top-head-sport">
                    <ul (click)="getAllSportsListData()">
                      <li><a>All Sports</a></li>
                    </ul>
                  </div>
                  <ul class="sidebar-menu" data-widget="tree">
                    <li class="treeview" *ngFor="let sports of allSportsList;let i= index">
                      <a (click)="sports.sport_id <= -100 ? goToCasino(sports) : getSeriesList(sports.sport_id)">
                        <span>{{sports.name}}</span><span class="pull-right-container"><i
                            class="fa fa-angle-right pull-right"></i></span>
                      </a>
                    </li>
                  </ul>
                </nav>
                <nav class="sidebar-nav" *ngIf="sportList == false">
                  <div class="top-head-sport">
                    <ul (click)="getAllSportsListData()">
                      <li><a>All Sports</a></li>
                    </ul>
                  </div>
                      <ul class="sidebar-menu" data-widget="tree">
                        <li class="treeview" *ngFor="let series of allSeriesList;let j= index" (click)="getMatchList(series, j)">
                          <a>{{series.name}} 
                            <span class="pull-right-container" [ngClass]="{'display-span': isShowMenu[j]}"> 
                              <i *ngIf="!isShowMenu[j]" class="fa fa-angle-right pull-right"></i>
                              <i *ngIf="isShowMenu[j]" class="fa fa-angle-down pull-down"></i>
                            </span> 
                          </a>
                          <ul class="treeview-menu" [ngClass]="{'display-list': isShowMenu[j]}">
                            <li *ngFor="let match of matchList[j];let k= index" (click)="matchDetail(match)">
                              <a> 
                                <i class="fa fa-arrow-right"></i> {{match.match_name}} 
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                </nav>
            </div>
            </div>
          </div>
      </main>
      <app-right-sidebar></app-right-sidebar>               
  </div>
  <app-footer-main></app-footer-main>
</div> -->

<div class="app-body footer-condition">
  <app-header></app-header>
    <div class="full-wrap">
      <div class="col-left">
        <app-sidebar></app-sidebar>
      </div>

      <div id="centerColumn" class="col-center">
        <!-- Loading Wrap -->
        <div id="loading" class="loading-wrap" style="top: 100px; display: none;">
            <ul class="loading">
                <li><img src="assets/sky_img/loading40.gif"></li>
                <li>Loading...
                </li>
                <br>
                <li><span id="progress"></span></li>
            </ul>
        </div>
        <!-- Message -->
        <div id="message" class="message-wrap success">
            <a class="btn-close">Close</a>
            <p></p>
        </div>
        <div id="oneClickLoading" class="loading-wrap" style="display: none;">
            <ul class="loading">
                <li><img src="assets/sky_img/loading40.gif"></li>
                <li id="oneClickTime">Place Bets
                </li>
            </ul>
        </div>
        <div class="marquee-box" style="display: none;">
            <h4>News</h4>
            <div class="marquee">
            </div>
        </div>
        
        <div class="over-wrap">
          <div class="promo-banner">
            <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                <div class="carousel-inner" >
                  <!-- <div class="carousel-item" *ngFor="let image of banner;let i = index;" [ngClass]="(i === 0) ? 'active' : ''" data-bs-interval="5000">
                    <img src="{{image.bannerUrl}}" class="d-block w-100" alt="...">
                  </div> -->
                </div>
            </div>
        </div>
          <div class="promo-banner-loading" style="display: none;"></div>


          <div class="mian-wrap">
            <div class="highlight-fix">
              <a class="a-search" (click)="openModalSearch(search)">Search</a>
              <div class="wrap-highlight ps ps--theme_default ps--active-x">
                <ul id="label">
                  <li class="select">
                    <span class="tag-live"><strong></strong> 3</span>
                    <a><img class="icon-cricket" src="assets/sky_img/transparent.gif"> Cricket</a>
                  </li>
                  <li>
                    <span class="tag-live"><strong></strong> 3</span>
                    <a><img class="icon-soccer" src="assets/sky_img/transparent.gif"> Soccer</a>
                  </li>
                  <li>
                    <span class="tag-live"><strong></strong> 3</span>
                    <a><img class="icon-tennis" src="assets/sky_img/transparent.gif"> Tennis</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="wrap-highlight_list">
              <h3>Highlights</h3>
              <ul class="highlight-list">
                <li id="noDatali" style="display: none;">There are no events to be displayed.</li>
                <li class="inplay-on">
                  <a>
                    <dl>
                      <dt>
                        <span id="streamingIcon" class="game-live" style="display: flex;">game-live</span>
                        <span id="lowLiquidityTag" class="game-low_liq" style="display: none;">Low Liquidity</span>
                        <span id="fancyBetIcon" class="game-fancy in-play" style="display: flex;"><pre>in-play</pre>Fancy</span>
                        <span id="bookMakerIcon" class="game-bookmaker in-play" style="display: flex;"><pre>in-play</pre>BookMaker</span>
                        <span id="feedingSiteIcon" class="game-sportsbook" style="display: none;">Sportsbook</span>
                        <span id="sportsBookIcon_1" class="game-sportsbook" style="display: none;">Premium Tennis</span>
                        <span id="sportsBookIcon_2" class="game-sportsbook" style="display: none;">Premium Cricket</span>
                        <span id="dateTimeInfo" class="time">In-Play</span>
                        <span id="sportsBookEIcon_1" class="game-E" style="display: none;"><i></i>Soccer</span>
                        <span id="sportsBookEIcon_137" class="game-E" style="display: none;"><i></i>e-Soccer</span>
                        <span id="sportsBookEIcon_4" class="game-E" style="display: none;"><i></i>Cricket</span>
                        <span id="sportsBookEIcon_2" class="game-E" style="display: none;"><i></i>Tennis</span>
                      </dt>
                      <dd id="eventName">Colombo Stars <span>v</span> Galle Gladiators</dd>
                    </dl>
                  </a>
                  <a id="multiMarketPin" class="pin-off"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="col-right">
          <div class="slip-wrap no-open-bet_slip">
              <h3>
                  <a class="to-expand">Bet Slip</a>
              </h3>
              <ul id="loadingMsg" class="loading" style="display: none">
                  <li><img src="assets/sky_img/loading40.gif"></li>
                  <li id="countDownTime">Place Bets</li>
              </ul>
              <p id="noBetSlipInfo">Click on the odds to add selections to the betslip.
              </p>
          </div>
      </div>
    </div>

  <app-footer-main></app-footer-main>
</div>

<!-- Search Modal -->
<ng-template #search>
  <div ngbDropdown class="search-top dropdown">
    <form class="d-flex position-relative">
        <span class="search-back ui-link"></span>
        <input ngbDropdownToggle class="form-control" id="dropdownMenuLink"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" type="text" autocomplete="off"
        [(ngModel)]="searchSport" [ngModelOptions]="{standalone: true}" placeholder="Search Events">
        <span class="search-clear" (click)="searchSport = '';modalRef.hide()"></span>
        <span class="search-collapse"></span>
        <div ngbDropdownMenu class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a ngbDropdownItem class="dropdown-item" *ngFor="let sport of homeData |search: searchSport :'match_name'">
                <div class="event-info" (click)="matchDetailDrop(sport)">
                    <div class="event-team">
                        <div class="team-name">{{sport?.match_name}}</div>
                    </div>
                </div>
            </a>
        </div>
        
    </form>                    
  </div>
</ng-template>